import clsx from 'clsx'
import { useRouter } from 'next/router'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { AuthLoginForm } from '@/components/features/auth'
import { PageWithHeader, PageWrapper } from '@/components/layout'
import { ErrorMessageList } from '@/components/ui'
import { ROUTE } from '@/const'

export const LoginPage = () => {
  const router = useRouter()
  const { t } = useTranslation()

  const [errorMessages, setErrorMessages] = useState<string[]>([])

  const handleSuccessLogin = () => {
    router.push(ROUTE.top)
  }

  return (
    <PageWithHeader
      withSearch={false}
      withMenu={false}
      withLinks={false}
      disableLogoLink={true}
    >
      <PageWrapper withBreadcrumb={false} spacingX={'sm'} pcWidth={'half'}>
        {errorMessages.length > 0 && (
          <div className={clsx('tw-mb-6 tw-text-center')}>
            <ErrorMessageList errorMessages={errorMessages} />
          </div>
        )}
        <h1 className={clsx('tw-text-center tw-text-lg tw-font-bold')}>
          {t('login.title')}
        </h1>
        <div className={clsx('tw-mt-6')}>
          <AuthLoginForm
            onSuccess={handleSuccessLogin}
            onChangeErrorMessage={setErrorMessages}
          />
        </div>
      </PageWrapper>
    </PageWithHeader>
  )
}
